import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ActionConfirmModal = ({ isOpen, action, client, onClose, onConfirm }) => {
  if (!isOpen || !client || !action) return null;

  const actionConfig = {
    suspend: {
      title: 'Suspend Client',
      message: 'Are you sure you want to suspend',
      icon: 'AlertCircle',
      color: 'warning',
      buttonText: 'Suspend',
      description: 'The client will not be able to access their account until suspension is removed.'
    },
    delete: {
      title: 'Delete Client',
      message: 'Are you sure you want to delete',
      icon: 'Trash2',
      color: 'destructive',
      buttonText: 'Delete',
      description: 'This is a soft delete. The client data will be archived and can be restored later.'
    }
  };

  const config = actionConfig?.[action];

  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-background/80 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="relative w-full max-w-md bg-card rounded-xl elevation-2xl overflow-hidden">
        <div className="p-6">
          <div className="flex items-start gap-4 mb-4">
            <div className={`w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 bg-${config?.color}/20`}>
              <Icon 
                name={config?.icon} 
                size={24} 
                color={`var(--color-${config?.color})`} 
              />
            </div>
            <div className="flex-1">
              <h2 className="text-xl font-heading font-semibold text-foreground mb-2">
                {config?.title}
              </h2>
              <p className="text-sm text-muted-foreground font-body">
                {config?.message} <span className="font-semibold text-foreground">{client?.companyName}</span>?
              </p>
            </div>
          </div>

          <div className={`p-4 bg-${config?.color}/10 border border-${config?.color}/20 rounded-md mb-6`}>
            <div className="flex items-start gap-2">
              <Icon name="Info" size={16} color={`var(--color-${config?.color})`} className="flex-shrink-0 mt-0.5" />
              <div className="space-y-1">
                <p className={`text-sm font-medium text-${config?.color} font-body`}>
                  {action === 'delete' ? 'This action can be undone' : 'Account access will be blocked'}
                </p>
                <p className="text-xs text-muted-foreground font-caption">
                  {config?.description}
                </p>
              </div>
            </div>
          </div>

          <div className="flex gap-3">
            <Button
              type="button"
              variant="outline"
              size="lg"
              onClick={onClose}
              fullWidth
            >
              Cancel
            </Button>
            <Button
              type="button"
              variant={config?.color}
              size="lg"
              onClick={onConfirm}
              iconName={config?.icon}
              iconPosition="left"
              fullWidth
            >
              {config?.buttonText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActionConfirmModal;